import React, { useEffect, useState } from 'react';
import T from 'prop-types';

import Tooltip from '../../../../../components/Tooltip';

const PromotionTooltip = ({ children }) => {
  const [visible, setVisible] = useState(false);

  const content = (
    <div className="notification-tooltip-box">
      <div className="notification-tooltip-close" onClick={() => setVisible(false)}>
        <i className="hicon-close-2 text-14 cursor-pointer" />
      </div>
      <h3 className="notification-tooltip-title">Get Notifications for New Reports</h3>
      <p className="notification-tooltip-text">
        We will send you an email letting you know when this report is updated.
      </p>
    </div>
  );

  useEffect(() => {
    // Add a delay before showing the tooltip to avoid overwhelming users immediately
    setTimeout(() => {
      setVisible(true);
    }, 1000);
  }, []);

  return visible ? (
    <Tooltip
      colorVariant="blue"
      visible={visible}
      content={content}
      placement="right"
      overlayClassName="notification-tooltip"
    >
      {children}
    </Tooltip>
  ) : (
    children
  );
};

PromotionTooltip.propTypes = {
  children: T.node.isRequired,
};

export default PromotionTooltip;
